<template>
  <div id="progressionAchievement">
    <h2  class="softTextShadow"><i class="fas fa-award"></i> Mes accomplissements</h2>
    <div class="flexwrap">
      <div id="achievements" class="paddingLeft">

        <badge icon="fa-house-chimney-heart" tooltip="Bienvenue" completed="true" color1="var(--watchColor2)" color2="var(--learnColor)" :scale="0.9"> </badge>
        <div @click="$router.push({name:'profile'})">
          <badge class="clickable" icon="fa-clipboard-list-check" tooltip="Profil complété" number="0"  :completed="profile.datas.profile_completed"
                 color1="var(--watchColor2)" color2="var(--learnColor)"></badge>
        </div>

        <!--
        <badge icon="fa-users" tooltip="Partagé sur les réseaux" completed="true"
               color2="#1FA2DE" color1="#4559A4" :scale="0.9"> </badge>
        <badge icon="fa-fire-flame-simple" tooltip="Abonnement premium pris" :scale="0.8" :completed="profile.datas.is_premium"
               color1="hsl(200, 20%, 10%)"
        color2="#ffda7b"></badge>-->

        <badge v-for="i of [3, 5, 1, 2, 10, 25]" :key="'g'+i"
               icon="fa-calendar-check" :tooltip="i+' semaine'+(i>1?'s':'')+' consecutive'+(i>1?'s':'')+' complétée'+(i>1?'s':'')" :number="i" :completed="profile.datas.max_week_streak>=i"
               color1="var(--goalBackgroundColor)" color2="var(--goalColor)"></badge>
        <badge v-for="i of [10, 100, 250, 1000]" :key="'l'+i"
               icon="fa-books" :tooltip="i +' mots vus'" :number="i" :completed="level_copper+level_silver+level_gold > i"
               color2="hsl(20, 55%, 35%)" color1="var(--goalBackgroundColor3)" :inverse="true" :scale="0.9"></badge>

        <badge v-for="i of [1, 10, 25, 100]" :key="'e'+i"
               icon="fa-popcorn" :tooltip="i +' épisode'+(i>1?'s':'')+' complété'+(i>1?'s':'')" :number="i" :completed="totalEpisodes>=i"
               color1="hsl(350, 55%, 45%)" color2="var(--goalBackgroundColor3)"></badge>



      </div>
      <div id="completedShows" v-if="!newbie">
        <div  v-for="(curseason, index) of completedSeasons"
              :key="index"
              class="flexwrap centercenter poster textShadow clickable completedShow mediumShadow"

              :style="{ backgroundImage: getBackground(showsData[seasonsData[curseason.season_id].show_id].poster_path)}"
              @click="changeSeason(curseason.season_id)"
              v-tooltip="showsData[seasonsData[curseason.season_id].show_id].english_title+(showsData[seasonsData[curseason.season_id].show_id].seasons.length>1?' '+seasonsData[curseason.season_id].english_title:'')">
              <span class="textShadow flexwrap centercenter"
                    style="position: absolute; bottom: 0; width: 45%; height: 45%; border-radius: 5vw; font-weight: bold; font-size: 0.9em;"
                    :style="'background-color: hsl('+showsData[seasonsData[curseason.season_id].show_id].hue+',80%,22%)'"
                    v-if="showsData[seasonsData[curseason.season_id].show_id].seasons.length>1"
              >{{seasonsData[curseason.season_id].num}}</span>
        </div>
        <div class="flexwrap centercenter completedShow" style="opacity: 0.09;"
             v-tooltip="'Complète une saison !'">

          <h2>?</h2>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

export default {
name: "badges",

  components: {
    Badge: () => import(/* webpackPrefetch: true */ '@/components/badge.vue'),
  },

  props: {
    newbie: Boolean,
    totalEpisodes: Number
  },

  computed: {
    ...mapGetters('global', [
        'isMobile',
      'dataLoaded',
      'fullWordsLearnt',
      'level_copper',
      'level_silver',
      'level_gold',
      'profile',
      'showsData',
      'seasonsData',
    ]),
    completedSeasons: function(){
      if(this.dataLoaded.ongoing){
        return this.profile.datas.user_seasons.filter(season => season.completed)
      }
      else
        return null

    },

  },

  methods: {
    ...mapActions('show', [
        'set_seasonRequested',
    ]),
    changeSeason: function(id) {
      this.set_seasonRequested(id)
    },
    getBackground: function (show_poster_path) {
      if (show_poster_path !== null) {
        return 'url(https://learnandwatch.s3.eu-west-3.amazonaws.com/small/' + show_poster_path + '), url(' + require('../assets/placeholder.png') + ')';
      } else {
        return ''
      }
    },
    getBackgroundBlur: function (show_background_path) {
      if (show_background_path !== null) {
        return 'https://learnandwatch.s3.eu-west-3.amazonaws.com/blur3/' + show_background_path ;
      } else {
        return ''
      }
    },
    selected: function (val) {
      this.$emit('selected', val);
    },
  }
}
</script>

<style scoped>
#progressionAchievement{
}
#achievements{
  display: grid;
  grid-gap: 0.8vw;
  grid-template-columns: repeat(4, 3vw);
  grid-template-rows: 3vw 3vw 3vw 3vw;
  grid-auto-flow: column;
  align-items: center;
  justify-items: center;
  color: hsl(220, 60%,70%);
}

#completedShows{
  display: grid;
  grid-gap: 0.8vw;
  grid-template-rows: repeat(4, 3vw);
  grid-template-columns: 3vw;
  align-items: center;
  justify-items: center;
  color:hsl(32, 50%, 10%);
  margin-left: 0.8vw;
}
.completedShow{
  height: 2.8vw;
  width: 2.8vw;
  border-radius: 5vw;

  background-color: hsl(220, 60%,70%);
  color: var(--navBackgroundColor);
  position: relative;
}

.poster{
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top center;
}

@media screen and (max-device-width: 767px) {
  #progressionAchievement{
    grid-column: 1/2;
    height: auto;
  }
  #achievements{
    padding-top: 1vw;
    grid-column-gap: 4vw;
    grid-row-gap: 3vw;
    grid-template-columns: repeat(4,    12vw);
    grid-template-rows: repeat(4,    12vw);
  }

  #completedShows{
    grid-gap: 3vw;
    grid-template-rows: repeat(4, 12vw);
    grid-template-columns: 12vw;
    margin-left: 4vw;
  }
  .completedShow{
    height: 10vw;
    width: 10vw;
    border-radius: 10vw;
  }
}
</style>